import {
  keepPreviousData,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  retrieveSettlementSummary,
  updateSettlementReportDefaultRole,
  type SettlementSummaryFilters,
} from "@/lib/data/requests/reports/reports-settlement-summary";
import { queryKeys } from "@/lib/data/static";

import type { APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import type { AxiosError } from "axios";
import toast from "react-hot-toast";

export const settlementSummaryQueryOptions = (
  filters: SettlementSummaryFilters,
) => ({
  queryKey: [queryKeys.reports, "settlement-summary", filters],
  queryFn: ({ signal }: { signal: AbortSignal }) =>
    retrieveSettlementSummary(filters, signal),
  placeholderData: keepPreviousData,
  refetchInterval: 30_000,
});

export function useUpdateSettlementReportDefaultRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateSettlementReportDefaultRole,
    onSuccess: (response) => {
      toast.success(
        response.data.pinnedRoleId
          ? "Default role pinned for everyone"
          : "Default role unpinned",
      );
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "The default role could not be saved");
    },
    onSettled: async () => {
      await queryClient.cancelQueries({
        queryKey: [queryKeys.reports, "settlement-summary"],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.reports, "settlement-summary"],
      });
    },
  });
}
